import React, { useContext, useEffect, useState } from "react";
import SchoolProfile from "../../Templates/Schools/SchoolProfile/SchoolProfile";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { classesURL, schoolURL } from "../../Hooks/URL";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";

function SchoolProfilePage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${schoolURL}/${id}`;
  const statisticsUrl = `${schoolURL}/${id}/statistics`;
  const page = "schools";

  const [Open, setOpen] = useState(false);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, page);

  const [school, setSchool] = useState({});
  const { data, loading, error } = useFetch(url);

  const [schoolNumbers, setSchoolNumbers] = useState({});
  const {
    data: SchoolNumbersData,
    loading: SchoolNumbersLoading,
    error: SchoolNumbersError,
  } = useFetch(statisticsUrl);

  const [classes, setClasses] = useState([]);
  const {
    data: classesData,
    loading: classesLoading,
    error: classesError,
  } = useFetch(`${classesURL}?sort=startDate&limit=6&page=1&schoolId=${id}`);

  const [goSave, setGoSave] = useState(false);
  const [goActivate, setGoActivate] = useState(false);

  const { loading: addLoading } = useSave({
    url: `${schoolURL}/${id}/resend-activation`,
    goSave,
    setGoSave,
  });
  const { loading: addActivateLoading } = useUpdate({
    url: `${schoolURL}/${id}/status`,
    goEdit: goActivate,
    setGoEdit: setGoActivate,
    newObject: {
      active: !school?.active,
    },
    refreshAfter: true,
  });

  useEffect(() => {
    if (!classesLoading && !classesError && classesData) {
      setClasses(classesData?.data?.data?.rows);
    }
  }, [classesData, classesLoading, classesError]);

  useEffect(() => {
    if (!SchoolNumbersError && !SchoolNumbersLoading && SchoolNumbersData) {
      setSchoolNumbers(SchoolNumbersData?.data);
    }
  }, [SchoolNumbersData, SchoolNumbersLoading, SchoolNumbersError]);

  useEffect(() => {
    if (!loading && !error && data) {
      setSchool(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "schools", data: school?.name });
  }, [school]);

  return (
    <SchoolProfile
      Open={Open}
      setOpen={setOpen}
      school={school}
      setSchool={setSchool}
      url={url}
      setGo={setGo}
      loading={loading}
      role={contextData?.role}
      classes={classes}
      // classesLoading={classesLoading}
      statistics={schoolNumbers}
      setGoSave={setGoSave}
      goSave={goSave}
      addLoading={addLoading}
      setGoActivate={setGoActivate}
      goActivate={goActivate}
      addActivateLoading={addActivateLoading}
    />
  );
}

export default SchoolProfilePage;
